import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class TermsConditionsComponent implements OnInit {

  constructor(private _location: Location) { }

  ngOnInit(): void {
  }

  back(){
    this._location.back();
  }
}
